import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import ApolloClient from 'apollo-boost'
import { ApolloProvider } from "@apollo/react-hooks";
import App from './App';

const client = new ApolloClient({
    // uri: 'https://graphql.dadiana.satisfaction.ai/',
    uri: 'https://api.blablazoom.satisfaction.ai/graphql',
    request: (operation) => {
        const token = localStorage.getItem('token');
        operation.setContext({
            headers: {
                    authorization: token ? `Bearer ${token}` : '',
            }
        })
    },
    resolvers: {}
});

ReactDOM.render(
    <ApolloProvider client={client} >
        <App />
    </ApolloProvider>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
